import React, { useState, useRef, Fragment } from "react";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import { getEducationSlidesForKey } from "constants/education";
import { getIconForUID } from "components/FormerEditor/utils";
import Analytics, { SHOW_INFO } from "utils/analytics";
const DEFAULT_CLASSES = {
  container:
    "flex flex-row pointer items-center ba hairline-1 bg-white bg-white--hover br2 ph2 pv1",
  copy: "f6 fw5 pr1"
};

const InfoIcon = ({ copy, uid, slides, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const modalRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const modalProps = {
    ref: modalRef,
    showModal,
    onClose: () => setShowModal(false)
  };
  const Icon = getIconForUID("help");

  return (
    <Fragment>
      <div
        className={classes.container}
        onClick={() => {
          uid &&
            Analytics.track(SHOW_INFO, {
              uid
            });
          setShowModal(true);
        }}
      >
        <div className={classes.copy}>{copy || "Help"}</div>
        <Icon />
      </div>
      <Modal {...modalProps}>
        <ModalContent slides={slides || getEducationSlidesForKey(uid)}>
          <ModalActions
            actions={[
              {
                cta: "Got it",
                onClick: () => setShowModal(false)
              }
            ]}
          />
        </ModalContent>
      </Modal>
    </Fragment>
  );
};

export default InfoIcon;
